import { Controller } from "@hotwired/stimulus"

// Plattform-spezifisches Tasten-Label: ⌘K auf Mac, STRG+K auf Win/Linux.
// Usage:
//   <kbd data-controller="os-kbd"
//        data-os-kbd-mac-value="⌘K"
//        data-os-kbd-other-value="STRG+K">⌘K</kbd>
//
// Mac-Erkennung via `navigator.platform` (Mac/iPhone/iPad/iPod). Veraltet,
// aber userAgentData ist noch nicht in allen Browsern verfuegbar — Fallback
// auf platform reicht hier voellig fuer ein optisches Detail.
export default class extends Controller {
  static values = {
    mac:   { type: String, default: "⌘K" },
    other: { type: String, default: "STRG+K" }
  }

  connect() {
    this.element.textContent = this.isMac() ? this.macValue : this.otherValue
  }

  isMac() {
    const p = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || ""
    return /Mac|iPhone|iPad|iPod/i.test(p)
  }
}
